<template>
    <div class="overview-container">
        <div v-if="getCurrentSMSCampaign" class="info-container">
            <v-card class="table-wrapper">
                <campaign-table :rows="campaignTableRows" />
                <create-form-actions
                    needs-padding
                    has-previous-step-btn
                    :has-submit-btn="!campaign"
                    :submit-loading="submitLoading"
                    :submit-disabled="submitLoading"
                    @reset="reset"
                    @cancel="cancel"
                    @previous-step="emitPrevStep"
                    @submit-campaign="submitCampaign"
                />
            </v-card>
        </div>
    </div>
</template>

<script>
    import dateTimeUtils from '@/utils/date-time-utils'
    import recurringSmsCampaignService from '@/services/recurring-sms-campaign-service'
    import CreateFormActions from '@/components/CreateFormActions.vue'
    import CampaignTable from '@/components/CampaignTable.vue'
    export default {
        components: {
            CampaignTable,
            CreateFormActions
        },
        props: {
            campaign: {
                type: Object,
                required: false,
                default: null
            }
        },
        data() {
            return {
                submitLoading: false
            }
        },
        computed: {
            campaignTableRows() {
                return [
                    {
                        header: 'Campaign :',
                        value: this.getCurrentSMSCampaign.alias
                    },
                    {
                        header: 'Originator :',
                        value: this.getCurrentSMSCampaign.originator
                    },
                    {
                        header: 'SMS Template :',
                        value: this.getCurrentSMSCampaign.textTemplate
                    },
                    {
                        header: 'Alias :',
                        value: this.getCurrentSMSCampaign.alias
                    },
                    {
                        header: 'Created At :',
                        value: this.getHumanizedDateTime(this.getCurrentSMSCampaign.createdAt)
                    }
                ]
            },
            getCurrentSMSCampaign() {
                return this.$store.getters.getCurrentRecurringSMSCampaign
            },
            isSMSCreate() {
                return this.$route.name.includes('Create')
            },
            filter() {
                return {
                    filter: { q: this.smsFilter },
                    range: [this.page - 1, this.size]
                }
            }
        },
        methods: {
            getHumanizedDateTime(dateTime) {
                return dateTimeUtils.getHumanizedDateTime(dateTime)
            },
            submitCampaign() {
                this.submitLoading = true
                recurringSmsCampaignService
                    .createSMSCampaign(this.getCurrentSMSCampaign)
                    .then((resp) => {
                        const campaignAfterCreate = {
                            ...this.getCurrentSMSCampaign,
                            id: resp.data.id
                        }
                        this.$store.dispatch(
                            'setCurrentRecurringSMSCampaign',
                            campaignAfterCreate
                        )
                        this.submitLoading = false
                        this.$emit('set-alert', 'Campaign Created', 'success')
                        setTimeout(() => {
                            this.$router.push(
                                `/recurring-sms/${this.getCurrentSMSCampaign.id}`
                            )
                        }, 3000)
                    }).catch((error) => {
                        this.$emit('set-alert', error.response.data.message, 'error')
                    })
            },
            emitPrevStep() {
                this.$emit('prev-step')
            },
            reset() {
                this.$emit('reset')
            },
            cancel() {
                this.$emit('cancel')
            }
        }
    }
</script>

<style scoped>
.overview-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.info-container {
    display: flex;
    column-gap: 10px;
}

.table-wrapper {
    padding-bottom: 1rem;
    width: 100%;
}

@media screen and (max-width: 992px) {
    .info-container {
        row-gap: 10px;
        flex-wrap: wrap;
    }
}
</style>
